import { useEffect, useState } from 'react';
import { fetchSiteStatus } from '../services/siteStatusService';

// Returns { away, backOn, message, loaded }
export default function useSiteStatus() {
  const [status, setStatus] = useState({ away: false, backOn: '', message: '', loaded: false });

  useEffect(() => {
    let cancelled = false;
    fetchSiteStatus().then((s) => {
      if (!cancelled) setStatus({ ...s, loaded: true });
    });
    return () => { cancelled = true; };
  }, []);

  return status;
}
